// Copyright 2005-2011 Jim Radford <radford@blackbean.org>, David Caldwell <david@porkrind.org> All rights reserved.

var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, generic_foundation=piles.generic_foundation, in_off_color_order=piles.in_off_color_order,
                              up=piles.up, down=piles.down, king=piles.king, score_order_by=piles.score_order_by, in_order_by=piles.in_order_by;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid, aspect=piles_ui.aspect;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE;
var options = require('./options'), option_def=options.option_def;
var solitaire = require('./solitaire').games;
var lib = require('./lib'), map=lib.map, add=lib.add;

solitaire.klondike = class extends pile_game {
    constructor(variant) {
        super()
        this.init_options(variant);
        if (!this.options.foundations) {
            this.complete = undefined;
            this.layout = this.layout_no_foundation;
            this.score = this.score_no_foundation;
        }
        if (this.options.turn_3) {
            this.layout = this.layout[0].layout;
        }
        this.pile_game_init(...arguments);
        if (this.options.foundations) {
            this.good = new Array(0);
            for (var c=1; c<=4; c++)
                this.good.push(new generic_foundation("good"+c, this, true));
        }
        this.work = new Array(0);
        for (var c=1; c<=7; c++)
            this.work.push(new this.constructor.work_pile("work"+c, this));
        this.create_deck();
        this.deck.maxstack = 52-28;
        this.deck.yoffset /= 2;
        this.play.overlap = true;
    }
    static variants = { klondike3: { turn_3:true },
                        solitaire: { alias: "klondike" },
                        klondikenf: { foundations: false }};

    valid_options = { turn_3: option_def("boolean", false, "Turn over 3 cards at once"),
                      redeal: option_def("boolean", true,  "Allow deck to be turned back over once all cards have been dealt"),
                      foundations: option_def("boolean", true, "Klondike with foundation piles")
                    };

    static work_pile = class extends pile {
        accept_stacks = true;
        accept(card) {
                    return this.pile.length == 0 && card[0].rank == king ||
                        this.pile.length      && in_off_color_order(card[0], this.top()) ? 1 : 0;
        }
        can_drag(index) { return this.pile[index].face == up; }
        xoffset = 0;
        splice = pile.prototype.splice_and_turn_over;
        maxstack = Math.ceil(10.2431141262842); // Determined by query in upgrades/maxstack.sql
    };

    create_deck() {
        this.deck = new pile("deck", this);
        this.play = new pile("play", this);

        super.create_deck(this.deck, this.play, this.options.turn_3 ? 3 : 1, this.options.redeal);
    }

    deal(deck) {
        for (var y=0; y<7; y++)
            for (var x=y; x<7; x++) {
                var c;
                this.work[x].push(c = deck.pop());
                c.face = x==y ? up : down;
            }
        this.deck.pile = deck;
    }

    is_complete() {
        if (this.options.foundations)
            return this.good[0].pile.length == 13 && this.good[1].pile.length == 13 &&
                   this.good[2].pile.length == 13 && this.good[3].pile.length == 13 && WON;
        else { // Copied from scorpion. Consider how to de-duplicate this.
            for (var i in this.work) {
                if (this.work[i].pile.length != 0 &&
                    (this.work[i].pile.length != 13 || !in_order_by(in_off_color_order, this.work[i].pile)))
                    return NOT_COMPLETE;
            }
            return WON;
        }
    }

    score() {
        return this.count_cards_in(this.good);
    }

    score_no_foundation() {
        return add(map(function(p) { return score_order_by(in_off_color_order, p.pile) }, this.work))
    }

    complete() {
        return this.complete_generic(this.good, [this.work, [this.play]]);
    }

    layout = [ { constraints: { wider: aspect.tablet_portrait, skinnier: aspect.phone_landscape },
                 layout: grid(["deck", {x: +.3}, "play",  void 0,  void 0,  "good1", "good2", "good3", "good4"],
                              [void 0, {x: +.3,
                                        y: +.1}, "work1", "work2", "work3", "work4", "work5", "work6", "work7"]), },
               { constraints: { skinnier: aspect.tablet_portrait },
                 layout: grid([          "deck", {x: +.3}, "play", {x: -.3}, void 0,  "good1", "good2", "good3", "good4"],
                              [{y: +.1}, "work1",          "work2",            "work3", "work4", "work5", "work6", "work7"]), },
               { constraints: { wider: aspect.phone_landscape, mobile: true },
                 layout: grid([          "deck", {x: +.3}, "play", {x: +.5}, "work1", "work2", "work3", "work4", "work5", "work6", "work7"],
                              [{y: +.1}, "good1", "good2"],
                              [          "good3", "good4"]), }];

    layout_no_foundation = grid(["deck", {x: +.2}, "play", "work1", "work2", "work3", "work4", "work5", "work6", "work7"]);
}

module.exports = solitaire.klondike;
// Copyright 2005-2011 Jim Radford <radford@blackbean.org>, David Caldwell <david@porkrind.org> All rights reserved.

var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, generic_foundation=piles.generic_foundation, in_off_color_order=piles.in_off_color_order,
                              up=piles.up, down=piles.down, king=piles.king, score_order_by=piles.score_order_by, in_order_by=piles.in_order_by;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid, aspect=piles_ui.aspect;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE;
var options = require('./options'), option_def=options.option_def;
var solitaire = require('./solitaire').games;
var lib = require('./lib'), map=lib.map, add=lib.add;

solitaire.klondike = class extends pile_game {
    constructor(variant) {
        super()
        this.init_options(variant);
        if (!this.options.foundations) {
            this.complete = undefined;
            this.layout = this.layout_no_foundation;
            this.score = this.score_no_foundation;
        }
        if (this.options.turn_3) {
            this.layout = this.layout[0].layout;
        }
        this.pile_game_init(...arguments);
        if (this.options.foundations) {
            this.good = new Array(0);
            for (var c=1; c<=4; c++)
                this.good.push(new generic_foundation("good"+c, this, true));
        }
        this.work = new Array(0);
        for (var c=1; c<=7; c++)
            this.work.push(new this.constructor.work_pile("work"+c, this));
        this.create_deck();
        this.deck.maxstack = 52-28;
        this.deck.yoffset /= 2;
        this.play.overlap = true;
    }
    static variants = { klondike3: { turn_3:true },
                        solitaire: { alias: "klondike" },
                        klondikenf: { foundations: false }};

    valid_options = { turn_3: option_def("boolean", false, "Turn over 3 cards at once"),
                      redeal: option_def("boolean", true,  "Allow deck to be turned back over once all cards have been dealt"),
                      foundations: option_def("boolean", true, "Klondike with foundation piles")
                    };

    static work_pile = class extends pile {
        accept_stacks = true;
        accept(card) {
                    return this.pile.length == 0 && card[0].rank == king ||
                        this.pile.length      && in_off_color_order(card[0], this.top()) ? 1 : 0;
        }
        can_drag(index) { return this.pile[index].face == up; }
        xoffset = 0;
        splice = pile.prototype.splice_and_turn_over;
        maxstack = Math.ceil(10.2431141262842); // Determined by query in upgrades/maxstack.sql
    };

    create_deck() {
        this.deck = new pile("deck", this);
        this.play = new pile("play", this);

        super.create_deck(this.deck, this.play, this.options.turn_3 ? 3 : 1, this.options.redeal);
    }

    deal(deck) {
        for (var y=0; y<7; y++)
            for (var x=y; x<7; x++) {
                var c;
                this.work[x].push(c = deck.pop());
                c.face = x==y ? up : down;
            }
        this.deck.pile = deck;
    }

    is_complete() {
        if (this.options.foundations)
            return this.good[0].pile.length == 13 && this.good[1].pile.length == 13 &&
                   this.good[2].pile.length == 13 && this.good[3].pile.length == 13 && WON;
        else { // Copied from scorpion. Consider how to de-duplicate this.
            for (var i in this.work) {
                if (this.work[i].pile.length != 0 &&
                    (this.work[i].pile.length != 13 || !in_order_by(in_off_color_order, this.work[i].pile)))
                    return NOT_COMPLETE;
            }
            return WON;
        }
    }

    score() {
        return this.count_cards_in(this.good);
    }

    score_no_foundation() {
        return add(map(function(p) { return score_order_by(in_off_color_order, p.pile) }, this.work))
    }

    complete() {
        return this.complete_generic(this.good, [this.work, [this.play]]);
    }

    layout = [ { constraints: { wider: aspect.tablet_portrait, skinnier: aspect.phone_landscape },
                 layout: grid(["deck", {x: +.3}, "play",  void 0,  void 0,  "good1", "good2", "good3", "good4"],
                              [void 0, {x: +.3,
                                        y: +.1}, "work1", "work2", "work3", "work4", "work5", "work6", "work7"]), },
               { constraints: { skinnier: aspect.tablet_portrait },
                 layout: grid([          "deck", {x: +.3}, "play", {x: -.3}, void 0,  "good1", "good2", "good3", "good4"],
                              [{y: +.1}, "work1",          "work2",            "work3", "work4", "work5", "work6", "work7"]), },
               { constraints: { wider: aspect.phone_landscape, mobile: true },
                 layout: grid([          "deck", {x: +.3}, "play", {x: +.5}, "work1", "work2", "work3", "work4", "work5", "work6", "work7"],
                              [{y: +.1}, "good1", "good2"],
                              [          "good3", "good4"]), }];

    layout_no_foundation = grid(["deck", {x: +.2}, "play", "work1", "work2", "work3", "work4", "work5", "work6", "work7"]);
}

module.exports = solitaire.klondike;
